/**
 * Shared utilities for the Comments feature.
 *
 * Anything used by more than one Comments component belongs here so that
 * formatting / display logic doesn't drift between the thread list, the
 * thread popover, and the inline comment item.
 */

/**
 * Format a date as a compact relative string for comment timestamps.
 *
 * Examples: "just now", "5m", "3h", "2d", or a locale-formatted date for
 * anything older than a week.
 */
export const formatRelative = (iso: string | Date): string => {
  const date = typeof iso === "string" ? new Date(iso) : iso;
  const diff = (Date.now() - date.getTime()) / 1000;
  if (diff < 60) return "just now";
  if (diff < 3600) return `${Math.floor(diff / 60)}m`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}h`;
  if (diff < 7 * 86400) return `${Math.floor(diff / 86400)}d`;
  return date.toLocaleDateString();
};
